import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from "../Banner";
import SubNav from "../SubNav";
import Footer from "../../Footer";
import CustomTable from "../../CustomTable.js";
import pricing from '../../../assets/Data/pricingData'

const stable = require("../../../assets/icons-pack/4.3 Object Storage Service/ic_01_stable.svg");
const secure = require("../../../assets/icons-pack/4.3 Object Storage Service/ic_02_secure.svg");
const efficient = require("../../../assets/icons-pack/4.3 Object Storage Service/ic_03_efficient.svg");
const easyofuse = require("../../../assets/icons-pack/4.3 Object Storage Service/ic_04_easyofuse.svg");

const OSS = () => {
    const heading = `OBJECT STORAGE SERVICE (OSS) `;
    const details = `Object Storage Service (OSS) is a stable, secure, efficient, and easy-to-use cloud storage service. `;

    const overview = [
        `OSS provides cost-effective and highly reliable access to storage. The OSS helps in reducing total cost of ownership while catering to various backup needs. `
    ];

    const advantages = [
        [
            `Stable`,
            `With reliability built into multiple levels of the architecture, OSS achieves very high data durability, and maintains an impressive service continuity rate. `,
            stable
        ],
        [
            `Secure`,
            `It secures your data with multiple protection mechanisms, including server-side encryption, URL validation, VPC-based network isolation, log auditing, and fine-grained permission control. `,
            secure
        ],
        [
            `Efficient `,
            `It improves experience by maximizing concurrency access to data at enlarged bandwidth while minimizing latency.`,
            efficient
        ],
        [
            `Easy to Use `,
            `OSS gives you the freedom to upload, download, and manage your data anytime, anywhere.`,
            easyofuse
        ]
    ];

    const functions = [
        [
            `Cost-Effective Pricing`,
            [`Pay per use or alternatively purchase yearly or monthly packages to enjoy lower prices.`]
        ],
        [
            `Durability and Availability `,
            [`OSS provides a highly reliable data center storage and cross-data-center disaster recovery.`]
        ],
        [
            `Secure`,
            [`OSS is equipped with powerful security protection mechanisms to ensure that your data remains safe.`]
        ]
    ];
    let TablesData = []
    pricing.map(price => {
        price.price = parseFloat(price.price).toFixed(2);
        if(price.name.includes('Object-Storage-Service') ){
            console.log(price,'price')
            price['monthlyPricing'] = price.price
            TablesData.push(price) 
        }
    })
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-storage"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} CustomTable={CustomTable} TablesData = {TablesData} onlyMonthly/>
            <Footer />
        </div>
    );
};

export default OSS;
